import { stack } from './stack';
import { column } from './column';
export var CalendarEventOverlapModes = {
  stack: stack,
  column: column
};